export class DemoAccountMutationError extends Error {
  isDemoAccountMutationError = true;
}
